<template>
  <!--
    - 하단 nav 있으면 > class.with-nav-main(default class)
    - 하단 nav 없으면 > class.without-nav-main
  -->
  <div :style="{height: '100rvh'}" id="app"  :class="mainClass">
    <modals-container class="ios-safari-modal-container"/>
<!--    <QAHelper :key="$route.fullPath"/>-->
    <fixed-header-wrapper v-if="hasHeader">
      <main-header></main-header>
    </fixed-header-wrapper> <!-- pooqzone 여부, headerTitle, -->
    <main-menu  v-if="device === 'mobile'"/>
    <component v-if="isVisibleAdultCheckView" :is="getAdultCheckViewComponent"></component>
      <login v-if="isVisibleLoginView" :is-window="true"></login>
      <router-view name="homeLayout" class="" />
      <router-view name="list" class="router-view-duration" :key="'list_router_view' + $route.fullPath"/>
      <router-view name="sumermultisection_with_gnb_code" class="router-view-duration" :key="'supermultisection_router_view' + $route.fullPath"/>
      <router-view name="sumermultisection_with_api" class="router-view-duration" :key="'supermultisection_router_view' + $route.fullPath"/>
      <router-view name="player" :key="'player_router_view_' + $route.fullPath"/>
      <router-view name="mypooq" key="mypooq"/>
      <router-view name="customer" key="customer"></router-view>
      <router-view name="voucher" key="voucher"/>
      <router-view name="agreement" key="agreement"/>
      <router-view name="event" key="event"/>
      <router-view name="login" key="login"></router-view>
      <router-view name="channel_clip" key="channel_clip"></router-view>  <!-- multisections -->
      <router-view name="pooqzone" key="pooqzone"></router-view>
      <router-view name="adultverify" key="adultverify"></router-view>
      <router-view name="cancelPopup" key="cancelPopup"></router-view>
      <router-view name="alarmNoticeList" key="alarmNoticeList"></router-view>
      <router-view name="lnbUserInfo" key="lnbUserInfo"></router-view>
      <router-view name="lnbEditUserProfile" key="lnbEditUserProfile"></router-view>
      <router-view name="lnbEditUserOneOfProfile" key="lnbEditUserOneOfProfile"></router-view>
      <router-view name="voucher_popup" key="voucher_popup"></router-view>
      <router-view name="voucher_popup_new" key="voucher_popup_new"></router-view>
      <router-view name="category_search" key="search-category-view"></router-view>
      <router-view name="schedule_view" key="schedule-view"></router-view>
      <router-view name="revocation_defense" key="revocation-defense"></router-view>
      <router-view name="shortcut" key="shortcut"></router-view>
      <router-view name="callback" key="callback"></router-view>
      <router-view name="cover" key="cover"></router-view>
      <router-view name="notfound" key="notfound"></router-view>
      <router-view name="wavvie_popup" key="wavvie_popup"></router-view>
    <router-view name="settings" key="adult_settings"></router-view>
    <router-view name="waiting" key="waiting"></router-view>
      <router-view name="event_emergency" key="event_emergency"></router-view>
    <router-view name="partners" key="partners"></router-view>
    <router-view name="voucher_popup_info" key="voucher_popup_info"></router-view>
    <router-view name="router_test" key="router_test"></router-view>
    <router-view name="search" key="search"></router-view>
    <router-view name="player_vod_detail_info" key="player_vod_detail_info"></router-view>
    <router-view name="player_movie_detail_info" key="player_movie_detail_info"></router-view>
      <LoadingWithStore/>
      <EventProcessor/>
    </div>
</template>
<script>
import FixedHeaderWrapper from '@/components/header/FixedHeaderWrapper'
import MainHeader from '@/components/header/template/MainHeader'
import { mapGetters } from 'vuex'
import MainMenu from '@/components/header/MainMenu'
import AdultCheckView from '@/views/adult/Adult'
import AdultCheckViewForApollo from '@/views/adult/AdultForApollo'
import Login from '@/views/login/Login'
import LoadingWithStore from '@/components/LoadingWithStore'
import { EventBus } from '@/components/eventbus/EventBus'
import AlertModal from '@/components/modal/AlertModal'
import ConfirmModal from '@/components/modal/ConfirmModal'
import { get } from 'lodash'
import {
  META_INFO_DEFAULT_DESCRIPTION,
  META_INFO_DEFAULT_OG_DESCRIPTION,
  META_INFO_DEFAULT_OG_IMAGE,
  META_INFO_DEFAULT_OG_SECURE_IMAGE, META_INFO_DEFAULT_OG_TITLE,
  META_INFO_DEFAULT_OG_URL,
  META_INFO_DEFAULT_TITLE
} from '@/common/constant'
import EventProcessor from '@/components/EventProcessor'
import utils from '@/common/util/utils'
import { isApp, sendKnock } from '@/common/util/common'
import { isApollo } from '@/common/utils/apollo.interface'
import { setRouteHistory } from '@/common/util/router.utils'

require('vue2-animate/dist/vue2-animate.min.css')
export default {
  components: {
    // vue100vh,
    EventProcessor,
    LoadingWithStore,
    AdultCheckView,
    AdultCheckViewForApollo,
    Login,
    MainMenu,
    MainHeader,
    FixedHeaderWrapper
  },
  data () {
    return {
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    ...mapGetters([ 'isVisibleAdultCheckView', 'isVisibleLoginView', 'isNavigationMenu' ]),
    hasHeader () {
      return get(this.$route, 'name', '') === 'home'
    },
    mainClass () {
      return this.isNavigationMenu ? 'with-nav-main' : 'without-nav-main'
    },
    getAdultCheckViewComponent () {
      return isApollo() ? 'adult-check-view-for-apollo' : 'adult-check-view'
    }
  },
  mounted () {
    sendKnock()
    EventBus.$on('open-alert', ({ text, callbackFn }) => {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) - 30
      const width = w > 300 ? 300 : w
      this.$modal.show(AlertModal,
        { text, callbackFn },
        { width, maxWidth: 300, height: 'auto', minHeight: 290, clickToClose: false }
      )
    })
    EventBus.$on('open-confirm', ({ text, resolveFn }) => {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) - 30
      const width = w > 300 ? 300 : w
      this.$modal.show(ConfirmModal,
        { text, resolveFn },
        { width, maxWidth: 300, height: 'auto', minHeight: 290, clickToClose: false }
      )
    })
  },
  watch: {
    $route (to) {
      setRouteHistory(to)
    }
  },
  metaInfo: {
    htmlAttrs: {
      lang: 'ko-KR',
      dir: 'ltr'
    },
    title: META_INFO_DEFAULT_TITLE,
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description', content: META_INFO_DEFAULT_DESCRIPTION, vmid: 'description', hid: 'description'
      },
      {
        property: 'og:title', content: META_INFO_DEFAULT_OG_TITLE, vmid: 'og:title', hid: 'og:title'
      },
      {
        property: 'og:type', content: 'website', vmid: 'og:type', hid: 'og:type'
      },
      {
        property: 'og:description', content: META_INFO_DEFAULT_OG_DESCRIPTION, vmid: 'og:description', hid: 'og:description'
      },
      {
        property: 'og:image:secure_url', content: META_INFO_DEFAULT_OG_SECURE_IMAGE, vmid: 'og:image:secure_url'
      },
      {
        property: 'og:image', content: META_INFO_DEFAULT_OG_IMAGE, vmid: 'og:image', hid: 'og:image'
      },
      {
        property: 'og:url', content: META_INFO_DEFAULT_OG_URL, vmid: 'og:url', hid: 'og:url'
      }
    ]
  },
  created () {
    if (isApp()) {
      import('./assets/scss/app.scss')
    }
  }
}

</script>
<style lang="scss" src=@/assets/scss/common.scss></style>
<style lang="css" src="@/assets/new-css/home-gnb.css"></style>
<style lang="css" src="@/assets/new-css/new-cell.css"></style>
<style lang="css" src="@/assets/new-css/play-detail.css"></style>
<style lang="css" src="@/assets/new-css/lnb.css"></style>
<style lang="css" src="@/assets/new-css/login.css"></style>
<style lang="css" src="@/assets/new-css/mypooq.css"></style>
<style lang="css" src="@/assets/new-css/customer.css"></style>
<style lang="css" src="@/assets/new-css/voucher.css"></style>

<style lang="css" src="@/assets/new-css/new-home.css"></style>
<style lang="css" src="@/assets/new-css/new-band.css"></style>
<style lang="css" src="@/assets/new-css/category.css"></style>

<!--홈 UI/UX 개편-->
<style lang="scss" src=@/assets/scss/category/band.scss></style>
<style lang="scss" src=@/assets/scss/category/list.scss></style>

<!--콘텐츠 전시 개편-->
<style lang="scss" src=@/assets/scss/category/detail.scss></style>

<style>
  #app {
    height: auto;
    min-height: 100vh;
  }

  .with-nav-main{
    padding-bottom: 50px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 50px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 50px);
  }

  .without-nav-main{
    padding-bottom: 0;
    padding-bottom: calc(constant(safe-area-inset-bottom));
    padding-bottom: calc(env(safe-area-inset-bottom));
  }

  .lnb-slide-duration,
  .router-view-duration {
    animation-duration: 450ms;
  }

  .ios-safari-modal-container {
    z-index: 9999999999999998;
    position: absolute;
  }

  .v--modal-overlay .v--modal-box {
    border-radius: 13px;
    box-shadow: 10px 10px 10px 0 rgba(0,0,0,.3) !important;
  }
</style>
